module.exports = __webpack_public_path__ + "img/kr-product-intl-card2-bg.54bf711.png";